import { Button, Col, Row } from "antd";
import Checkbox from "antd/es/checkbox/Checkbox";
import { useEffect, useState } from "react";
import { FaKey } from "react-icons/fa";
import { FiTrash } from "react-icons/fi";
import { useAuthLayoutContext } from "../../../context/AuthLayoutContext";
import { useChatContext } from "../../../context/ChatContext";
import { useInfoUser } from "../../../store/UserStore";
import { formatTime } from "../../../utils/formatTime";
import { CustomAvatar } from "../../avatar/CustomAvatar";
import { useDirectoryContext } from "./DirectoryContext";

const BasicMemberInfoV2 = ({
  member,
  memberGroup,
  screenInfo,
  onChangeMembersCheckBox,
  isHost,
  isMe,
  isAdmin,
  hasRead,
  lastSeenTs,
  isSelectedCombobox,
  seenTsInMessage,
  isView,
  isCC,
  isModaReaction,
}) => {
  const { user, languageMap } = useInfoUser();
  const { onDeleteItem } = useDirectoryContext();
  const { orgList } = useAuthLayoutContext();
  const chatContext = useChatContext();
  const { selectedConversation } = chatContext || {};
  const [isMobile, setIsMobile] = useState(window.innerWidth < 860);

  const completeMember = orgList?.find(
    (org) => org.userCode === member?.userId,
  );

  const handleResize = () => {
    setIsMobile(window.innerWidth < 860);
  };

  const getIconFromScreenInfo = () => {
    switch (screenInfo) {
      case "CREATE_GROUP": {
        return (
          <Button
            className="bg-[#e00d0d] text-[white]"
            onClick={() => onDeleteItem(memberGroup?.paths?.[0])}
            icon={<FiTrash className="text-[18px]" />}
          ></Button>
        );
      }
      case "VIEW_MEMBER_IN_GROUP": {
        if (isHost) {
          return <FaKey className="bi bi-key text-[18px] align-icon" />;
        } else if (
          selectedConversation?.role === "HOST" &&
          selectedConversation?.type !== "NOTIFICATION"
        ) {
          return (
            <>
              {!isModaReaction && (
                <Checkbox
                  checked={isSelectedCombobox}
                  value={memberGroup?.userId}
                  onChange={(e) => {
                    onChangeMembersCheckBox(e?.target?.value);
                  }}
                />
              )}
            </>
          );
        } else {
          return <div />;
        }
      }
      case "READ_UNREAD": {
        return <div>{formatTime(member?.readTs)}</div>;
      }

      default: {
        return <div />;
      }
    }
  };

  const generateRoleNameChatting = () => {
    if (isHost) {
      return (
        <span className="text-xs">
          {languageMap?.["chat.role.conversation.host"] ?? "Host"}
        </span>
      );
    } else if (isAdmin) {
      return (
        <span className="text-xs">
          {languageMap?.["chat.role.conversation.admin"] ?? "Admin"}
        </span>
      );
    } else
      return (
        <span className="text-xs">
          {languageMap?.["chat.role.conversation.member"] ?? "Member"}
        </span>
      );
  };

  const generateRoleNameNotification = () => {
    return (
      <span>
        {member?.role
          ?.map((role) => {
            if (role === "SENDER")
              return (
                languageMap?.["chat.role.conversation.noti.sender"] ?? "sender"
              );
            if (role === "RECIPIENT")
              return (
                languageMap?.["chat.role.conversation.noti.recipient"] ??
                "recipient"
              );
            if (role === "CC")
              return (
                languageMap?.["chat.role.conversation.noti.cc"] ?? "reference"
              );

            return null;
          })
          .filter(Boolean)
          .join(", ")}
      </span>
    );
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Row
      gutter={isMobile ? [4, 0] : [8, 0]}
      className="w-full mb-5 items-center"
    >
      <Col span={isMobile ? 5 : 3} className="flex items-center justify-center">
        <CustomAvatar
          person={completeMember}
          userId={member?.userId}
          pos={-1}
          styleCss={{}}
          isShowUserStatus={{ status: true, isAlwaysTrue: false }}
        />
      </Col>
      <Col span={isMobile ? 15 : 18} className="items-center justify-center">
        <Row
          gutter={isMobile ? [4, 0] : [8, 0]}
          className="items-center justify-center text-sm"
        >
          <Col span={isModaReaction ? 17 : isMobile ? 24 : 10}>
            <span
              className={
                isMe
                  ? "font-bold text-[#0091FF] text-[14px]"
                  : "font-bold text-[14px]"
              }
            >
              {isMe
                ? languageMap?.["chat.role.conversation.you"] ?? "You"
                : completeMember?.name}
            </span>
            <br />
            {generateRoleNameNotification()}
          </Col>
          <Col span={isMobile ? 24 : 14}>
            <span className="text-[red]">*</span>
            <span>
              {completeMember?.paths?.map((path) => path?.name).join(" > ")}
            </span>
          </Col>
        </Row>
      </Col>
      <Col
        span={seenTsInMessage ? 2 : 3}
        className="flex flex-1 items-center justify-end text-[10px]"
      >
        {getIconFromScreenInfo()}
      </Col>
    </Row>
  );
};

export { BasicMemberInfoV2 };
